import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { UserAsset } from '@models/dashboard.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ModalService } from '@services/modal/modal.service';

@Component({
  selector: 'ts-confirm-upgrade-eligible',
  templateUrl: './confirm-upgrade-eligible.component.html',
  imports: [CommonModule, TranslationPipe]
})
export class ConfirmUpgradeEligibleComponent {
  @Input() modal_header: string;
  @Input() asset: UserAsset;
  @Output() confirm_upgrade_eligible: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('upgradeDeviceModal') upgrade_device_template: TemplateRef<any>;

  constructor(private modal_service: ModalService) {}

  get date(): string {
    return new Date(this.asset.line.upgrade_eligible_date!).toLocaleString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }

  continue(): void {
    this.confirm_upgrade_eligible.emit(true);
  }

  dismissModal(): void {
    this.modal_service.dismissLastModal('Close click');
  }
}
